import styled from 'styled-components'
import theme from 'src/styles/theme'

export const Container = styled.div<{isRestockingFresh?: boolean}>`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  background-color: ${({ isRestockingFresh }) => (isRestockingFresh ? theme.colors.confirm : theme.colors.darkBlue)};
  color: ${theme.colors.white};
  margin-top: 10px;
  width: 100%;
  height: 60px;
`
